export class UnknownError extends Error {
	constructor() {
		super();
		this.name = 'UnknownError';
		this.message = 'There is something wrong and ErrorBoundary component catch an undefined error.';
	}
}
